import React, { useState, useEffect, useContext } from 'react';
import DateFormatService from "../../controller/DateFormatController/DateFormatController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";

function DateFormatPage() {
    const navigate = useNavigate();
   const { theme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [DateFormatList, setDateFormatList] =  useState([]);
   

    const fetchDateFormat = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
           
            const dateFormat = await DateFormatService.GetAll(redirectCallback);
            setDateFormatList(dateFormat);
            
        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };
    useEffect(() => {
        fetchDateFormat();
    }, []);

    
    const handleBaseCurrencyToggle = async (ID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
           // alert(ID);
           await DateFormatService.SetDateFormat(redirectCallback,ID);
            fetchDateFormat();

        } catch (error) {
            console.error('API request failed:', error);
        }
    };

    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>
                       
                        <th>Date Format</th>
                        <th style={{ "textAlign": "right" }}>Default Format</th>
                    </tr>
                </thead>
                <tbody>
                    {DateFormatList.length === 0 ? (
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'center' }}>No Format is available...</td>
                        </tr>
                    ) : (
                        DateFormatList.map((format, index) => (
                            <tr key={index}>
                                <td>{format.DateFormat}</td>
                                
                                <td style={{ "textAlign": "right" }}>
                                    <button
                                        className={`btn ${format.IsActive === 1 ? 'btn-success' : 'btn-secondary'}`}
                                        onClick={() => handleBaseCurrencyToggle(format.ID)}
                                    >
                                        {format.IsActive === 1 ? 'On' : 'Off'}
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
           
        </div>
    );
}

export default DateFormatPage;
